// Message status colors for inbox and outbox grids
export const MESSAGE_COLORS = {
  STATUS_NEW: '#B6DB80',       //light green
  STATUS_READ: 'transparent', 
  STATUS_REPLIED: '#ffffe0',   //light yellow
  STATUS_DEL: '#eba5a3',     
  STATUS_DELBYRECIP: '#f5e7e5', 
  STATUS_DELBYSENDER: '#f1c1c0',
  STATUS_VIEWED: 'transparent', 
  LINK_BLUE: '#1a73e8',  // Link and interactive colors
  
  // Additional colors
  TRANSPARENT: 'transparent',
} as const;

// Export individual colors for convenience
export const {
  STATUS_NEW,
  STATUS_READ,
  STATUS_REPLIED,
  STATUS_DEL,
  STATUS_DELBYRECIP,
  STATUS_DELBYSENDER,
  STATUS_VIEWED,
  LINK_BLUE,
  TRANSPARENT,
} = MESSAGE_COLORS;
